import angular from "angular";
import component from "./params-control.component";

angular.module('paramsControl', [component]);

export default 'paramsControl';


// WEBPACK FOOTER //
// ./resources/assets/modules/params-control/params-control.module.js